<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新建比赛': '修改比赛信息'",width="95%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()")
      el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="140px", @submit.native.prevent)
          el-card(shadow="never")
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 比赛设置
            div
              el-form-item(label="比赛ID:" prop="matchId" v-show="false")
                   el-input.width_ct(v-model="ruleForm.matchId" disabled)
                   font.font_later(v-if="!ruleForm.matchId") 新建后自动生成!
              el-form-item(label="比赛名称:" prop="matchName")
                  el-input.width_ct(v-model="ruleForm.matchName" @input="descInput"  placeholder="请填写比赛名称" type="text" maxlength="40" show-word-limit)
                  font.font_later 您还可以输入
                  font.font_style {{nameFont}}
                  font.font_color 个字!
              el-form-item(label="主办方:" prop="userGroupId")
                  el-select.sel_width_ct(v-model="ruleForm.userGroupId" placeholder="请选择主办方" filterable clearable @change="changeCity")
                      el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-form-item(label="主办城市:" prop="city")
                  el-col(style="width:20%;")
                      el-select(v-model="ruleForm.provinceCode" placeholder="请选择省" style="width:100%;" :disabled="cityDisbaled" @change="changeProvice")
                          el-option(v-for="(item,index) in provinceList",:key="index",:label="item.name",:value="item.code" )
                  el-col(style="width:2%;" class="line") &nbsp;&nbsp;省&nbsp;&nbsp;
                  el-col(style="width:20%;")
                      el-select(v-model="ruleForm.cityCode" placeholder="请选择市" style="width:100%;" :disabled="provinceDisabled" @change="selectCity")
                          el-option(v-for="(item,index) in cityList",:key="index",:label="item.cityname",:value="item.citycode" )
                  el-col(style="width:20%;") &nbsp;&nbsp;市&nbsp;
              el-form-item(label="比赛场地:" prop="venueId")
                  el-select.sel_width_ct(v-model="ruleForm.venueId" placeholder="请选择比赛场地" clearable :disabled="venueIdDisabled" @change="venueIdChange")
                      el-option(v-for="(item,index) in venueList" :key="index" :label="item.name" :value="item.id")
                  font.font_later(v-if="ruleForm.venueAddress") 地址: {{ruleForm.venueAddress}}
              el-form-item(label="比赛类型:" prop="ctType")
                  el-select.sel_width_ct(v-model='ruleForm.ctType' @change='changectType'  placeholder="请选择比赛类型"  clearable)
                      //- el-option(label="月度赛-资格赛" :value='5')
                      //- el-option(label="月度赛-级别赛" :value='6')
                      //- 全局搜索,替换
                      el-option(label="挑战赛" :value='5')
                      el-option(label="群英赛" :value='6')
                      //- el-option(label="年度总决赛" :value='4')
              el-form-item(label="签位:" prop="applySize")
                    el-col(style="width:15%;")
                        el-input(v-model='ruleForm.applySize' @change='changeappsize' clearable placeholder="请填写签位数")
                    el-col(style="width:25%;")
                        el-form-item(label="级别队伍数量:" prop="teamNum")
                          el-input(v-model='ruleForm.teamNum' style="width:100%;" @change='changeappsize' clearable placeholder="请填写级别队伍数量")

              //- 迭代三
              el-form-item(label="第一阶段赛制:" prop="FirstCompetition")
                    el-col(style="width:15%;")
                        el-select(v-model='ruleForm.FirstCompetition' style="width:100%;" placeholder="请选择赛制" @change='changeFirstCompetition' clearable)
                          el-option(v-for="(item, index) in FirstCompetition" :label="item.label" :value='item.value' )
                    //- el-col(style="width:8%;text-align:right;" class="line") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*组数&nbsp;&nbsp;
                    el-col(style="width:25%;")
                      el-form-item(label="*组数:" prop="groupNum")
                        el-input(v-model='ruleForm.groupNum' :disabled='ruleForm.FirstCompetition===1?false:true' @change='changeGroupNum'  style="width:100%;" @input='changeGpnumber' clearable placeholder="请填写组数")
              el-form-item(label="第二阶段赛制:")
                  el-col(style="width:15%;")
                      el-select(v-model='ruleForm.SecondCompetition' style="width:100%;" placeholder="请选择赛制" @change='changeSecondCompeti'  clearable :disabled='ruleForm.FirstCompetition===1&&ruleForm.groupNum!=1&&ruleForm.groupNum!=""?false:true')
                        el-option(v-for="(item, index) in SecondCompetition" :label="item.label" :value='item.value')
                  //- el-col(style="width:8%;text-align:right;" class="line") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*交叉数&nbsp;&nbsp;
                  el-col(style="width:25%;")
                    el-form-item(label="*交叉数:" prop="")
                      el-select(v-model='ruleForm.crossNum' style="width:100%;" placeholder="请选择交叉数" @change='changecrossNum'  clearable :disabled='ruleForm.SecondCompetition==4?false:true')
                        el-option(v-for="(item, index) in CrossingNum" :label="item.label" :value='item.value')
              el-form-item(label="积分起始点:" prop="startScore")
                      el-input.sel_width_ct(v-model='ruleForm.startScore'  clearable placeholder="请填写积分起始点" )
                      span(style='font-size:14px;margin-left:10px;color:rgb(98 98 98)') 积分（默认1积分，可修改）
              el-form-item(label="是否第六人:")
                    el-radio(v-model="ruleForm.competitionClub.sixthMan" :label='1') 是
                    el-radio(v-model="ruleForm.competitionClub.sixthMan" :label='0') 否
              el-form-item(label="报名时间:" prop="applyDate")
                  el-date-picker(v-model="ruleForm.applyDate" @blur="applyDateChange" range-separator="至" type="datetimerange" start-placeholder="开始时间" end-placeholder="截止时间" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :clearable="false")
              //- el-form-item(label="报名时间:" prop="applyDate")
              //-     el-date-picker(v-model="ruleForm.applyDate" @blur="applyDateChange" range-separator="至" type="datetimerange" start-placeholder="开始时间" end-placeholder="截止时间" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :clearable="false")
              //- el-form-item(label="调整报名名单时间:" prop="applyDate")
              //-     el-date-picker(v-model="ruleForm.RegistrationList" @blur="applyDateChange" range-separator="至" type="datetimerange" start-placeholder="开始时间" end-placeholder="截止时间" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :clearable="false")
              el-form-item(label="调整报名名单时间:" prop="RegistrationList")
                  el-date-picker(v-model="ruleForm.RegistrationList" @blur="applyDateChange1" :disabled="ruleForm.applyDate.length===0" :picker-options="pickerOptionsCt" range-separator="至" type="datetimerange" start-placeholder="开始时间" end-placeholder="截止时间"  format="yyyy-MM-dd HH:mm"  value-format="yyyy-MM-dd HH:mm" :clearable="false")

              el-form-item(label="调整出场名单时间:" prop="AttendanceList")
                  el-date-picker(v-model="ruleForm.AttendanceList"  @blur="applyDateChange2"  :disabled="ruleForm.RegistrationList.length===0" :picker-options="pickerOptionsCt1" range-separator="至" type="datetimerange" start-placeholder="开始时间" end-placeholder="截止时间"  format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :clearable="false")
              el-form-item(label="比赛时间:" prop="matchStartTime")
                  el-date-picker(v-model="ruleForm.matchStartTime" type="datetime" :disabled="ruleForm.AttendanceList.length===0"  :placeholder="matchStartTimePlaceholder" format="yyyy-MM-dd HH:mm" @change="changeMatchStartTime"  :picker-options="pickerOptionsCt2" value-format="yyyy-MM-dd HH:mm" :clearable="false")
              el-form-item(label="列表页图:" prop="imgList")
                  el-input(v-model="ruleForm.imgList" v-show="false")
                  //- el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                  img(v-if="listImageUrl" :src="listImageUrl" class="avatar" style="width:256px;height:190px;" @click="openImgdailog(1)")
                  i(v-else class="el-icon-plus avatar-uploader-icon" style="width:240px;height:174px;" @click="openImgdailog(1)")
                  imgupload(v-if="openImg" ref="upimg" :width="256" :height="190" @uploadSuccess='doneup_lb')
                  el-alert(title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top:10px")
              el-form-item(label="详情页图:" prop="imgDetailList")
                  el-input(v-model="ruleForm.imgDetailList" v-show="false")
                  //- el-upload(:http-request="uploadFileDetail",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                  img(v-if="detailImageUrl" :src="detailImageUrl" class="avatar" style="width:750px;height:310px" @click="openImgdailog(2)")
                  i(v-else class="el-icon-plus avatar-uploader-icon" style="width:317px;height:178px" @click="openImgdailog(2)")
                  imgupload(v-if="openImg" ref="upimg2" :width="750" :height="310" @uploadSuccess='doneup_xq')
                  el-alert(title="建议最小分辨率750×310,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top:10px")
              el-form-item(label="比赛简介:" prop="matchDescription")
                  d2-quill(ref="d2-quill" v-model="ruleForm.matchDescription" style="min-height: 200px;")
              el-form-item(label="报名须知:" prop="gameDescription")
                  el-input(v-model="ruleForm.gameDescription" type="textarea" :rows=6 resize="none" placeholder="请输入报名须知")
          br
          el-card(shadow="never")
            div(slot="header")
              font(style="font-weight: bold;font-size:18px;") 报名限定
            div
              el-form-item(label="报名限定:" prop="presidentLimit")
                  el-radio(:label=0 v-model="ruleForm.presidentLimit") 限会长
                  el-radio(:label=1 v-model="ruleForm.presidentLimit") 不限
              el-form-item(label="队伍人数:")
                  el-input-number(v-model="ruleForm.teamMin" :disabled='true'   :min=0  :max="teamMaxSelect" @change='teamMaxChange')
                  font &nbsp;---&nbsp;
                  el-input-number(v-model="ruleForm.teamMax"  :min="teamMinSelect" :max=100 @change='teamMinChange')
                  font &nbsp;人&nbsp;
              el-form-item(label="俱乐部等级:" prop="presidentLimit")
                  <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(city,index) in cities" :label="city.label" :disabled="city.disabed" :key="index">{{city.value}}</el-checkbox>
                  </el-checkbox-group>
            el-collapse(v-model="activeNames")
              el-collapse-item(title="显示更多" name="1")
                el-form-item(label="重复报名:" prop="repeatSign")
                    el-radio(:label=0 v-model="ruleForm.repeatSign") 不允许
                    el-radio(:label=1 v-model="ruleForm.repeatSign") 允许
                el-form-item(label="性别限定:" prop="genderLimit")
                    el-radio-group(v-model="ruleForm.genderLimit" @change="genderLimitChange")
                        el-radio(:label='2') 全部
                        el-radio(:label='0' style='margin-left:14px;') 男
                        el-radio(:label='1') 女
                el-form-item(label="年龄限定:")
                    font &nbsp;男选手&nbsp;
                    el-input-number(v-model="ruleForm.ageMinMen" :disabled="menDisabled"  :min=0  :max="ageMaxMenMax" @change='startAgeMenChange')
                    font &nbsp;至&nbsp;
                    el-input-number(v-model="ruleForm.ageMaxMen"  :disabled="menDisabled" :min="ageMaxMenMin" :max=100 @change='endAgeMenChange')
                    font &nbsp;岁&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;女选手&nbsp;
                    el-input-number(v-model="ruleForm.ageMinWomen"  :disabled="womenDisabled" :min=0 :max="ageMaxWomenMax" @change='startAgeWomenChange')
                    font &nbsp;至&nbsp;
                    el-input-number(v-model="ruleForm.ageMaxWomen"  :disabled="womenDisabled" :min="ageMaxWomenMin" :max=100 @change='endAgeWomenChange')
                    font &nbsp;岁
                el-form-item(label="年度积分≥" prop="scoreMin")
                  el-input-number(v-model="ruleForm.scoreMin" :min="0" :max="100000000" style='margin-left:50px;')
                  font.font_later 请限定选手年度积分！
          br
          el-card(shadow="never")
              div(slot="header")
                  font(style="font-weight: bold;font-size:18px;") 报名费用
              div
                  el-table(:data="ruleForm.ctEnrollPriceList" border)
                      el-table-column(prop="name" label="项目" align='center')
                      el-table-column(prop="type" label="报名费用" align='center')
                        template(slot-scope="scope")
                              font ￥&nbsp;&nbsp;
                              el-input-number(v-model ="scope.row.price" :precision="2" :min="0" :max="1000000")
                              font &nbsp;&nbsp;&nbsp;&nbsp;元

          br
          el-card(shadow="never")
              div(slot="header")
                  font(style="font-weight: bold;font-size:18px;") 退款设置
              div
                  el-row(style="padding-bottom:15px;" :span="24")
                        el-col(:md='23' :sm="5")
                            el-button(@click='addFeeTemplate(2)'  type='primary') 选择模板
                  el-row
                     el-col(:span="8")
                          el-form-item(label="距比赛开始≤" label-width="auto")
                              el-input-number(v-model="ctRefund.minDuration" :min="0" :max="100000000" :step="1")
                              font &nbsp;&nbsp;&nbsp;小时
                     el-col(:span="8")
                          el-form-item(label="退款比例:")
                              el-input-number(v-model="ctRefund.refundScale" :min="0" :max="100")
                              font &nbsp;&nbsp;&nbsp;%
                     el-col(:span="8" )
                           div(style="float:right")
                               el-button(@click="addCtRefund" type="primary") 添 加
                               el-button(@click="delCtRefund" type="danger" :disabled="delCtRefundDisabled") 删 除
                  el-table(:data="ruleForm.ctRefundList" border @selection-change='selectionChangeHandle',)
                     el-table-column(type='selection', align='center', width='50')
                     el-table-column(prop='index' label="序号"  align='center', width='100')
                     el-table-column(prop="minDuration" label="距比赛开始时间/小时（含）" align='center')
                     el-table-column(prop="refundScale" label="退款比例/%" align='center')
          br
          el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 电子证书设置
                el-select.sel_width_ct(v-model='ruleForm.prizeList'  clearable  placeholder="请选择奖项等级" style='margin-bottom: 10px')
                    el-option(v-for="item in prizeList" :label="item.label" :value="item.key")
                el-form-item(label="电子证书图:" prop="CertimgList")
                    i( class="el-icon-plus avatar-uploader-icon" style="width:240px;height:174px;" @click="openImgdailog(3)")
                    div(class='imagemore')
                        div(class='imagelist')
                            div(class='infocont'  v-for="(item,index) in listImageUrlCert" @mouseenter="hoverover(item)" @mouseleave="hoverout(item)")
                                div(class='deletes' v-if='deletesId === item.imgUrl')
                                    div(class='Mask')
                                    div
                                    <i :class="activecolor===item.imgUrl?'el-icon-delete chosecolor':'el-icon-delete'" @mouseenter="hoverover1(item)" @mouseleave="hoverout2(item)" @click="deletecertImg(item,index)"></i>
                                div
                                img(v-if="listImageUrlCert" :src="item.imgUrl" class="avatar" style="width:240px;height:174px;" @click="openImgdailog(3)")
                                span() {{item.rewardLevel==1?'一等奖':item.rewardLevel==2?'二等奖':item.rewardLevel==3?'三等奖':item.rewardLevel==4?'四等奖':''}}
                            div
                        div
                    div
                    imguploadMD(v-if="openImg" ref="upimg3" :width="240" :height="174" @uploadSuccess='doneup_Cert')
                el-alert(title="建议最小分辨率240×175,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top:10px")
      span.dialog-footer(slot="footer")
          el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 确 定
          el-button(@click="closeForm()") 取 消
      //- 选择模板
      addFeeTemplate(v-if='addFeeTemplateVisible', ref="addFeeTemplate", @chooseTemplate='chooseTemplate')
</template>
<script>
import addFeeTemplate from '../../../operation/fee/add-fee-template.vue'
import { commomDictData } from '@/util/dictionary' // 字典项
export default {
	components: {
		addFeeTemplate
	},
	data () {
		return {
			disabedJY: true,
			disabedTT: false,
			checkedCities: [],
			cities: [
				{
					label: '1',
					value: '甲A',
					disabed: true
				},
				{
					label: '2',
					value: '甲B',
					disabed: true
				},
				{
					label: '3',
					value: '乙A',
					disabed: true
				},
				{
					label: '4',
					value: '乙B',
					disabed: true
				},
				{
					label: '5',
					value: '丙A',
					disabed: true
				},
				{
					label: '6',
					value: '丙B',
					disabed: true
				},
				{
					label: '7',
					value: '丁A',
					disabed: true
				},
				{
					label: '8',
					value: '丁B',
					disabed: true
				},
				{
					label: '9',
					value: '资格甲',
					disabed: true
				},
				{
					label: '10',
					value: '资格乙',
					disabed: true
				},
				{
					label: '11',
					value: '资格丙',
					disabed: true
				},
				{
					label: '12',
					value: '资格丁',
					disabed: true
				}
			],
			activecolor: -1,
			deletesId: -1,
			activeNames: ['0'],
			ctRefund: {
				index: 0,
				minDuration: 0,
				refundScale: 0
			},
			defaultTime: [],
			defaultValue: [],
			defaultValue1: [],
			addFeeTemplateVisible: false,
			teamMaxSelect: 100,
			teamMinSelect: 0,
			clickFlag: false,
			delTableList: [],
			sysOrgList: [],
			cityList: [],
			provinceList: [],
			delCtRefundDisabled: true,
			cityDisbaled: true,
			provinceDisabled: true,
			nameFont: 40,
			venueIdDisabled: true,
			venueList: [],
			placesInfoList: [],
			ageMaxMenMin: 0,
			ageMaxWomenMin: 0,
			ageMaxMenMax: 100,
			ageMaxWomenMax: 100,
			menDisabled: false,
			womenDisabled: false,
			ruleForm: {
				id: null,
				clubLimit: '',
				matchType: '2',
				matchId: '',
				matchName: '',
				userGroupId: '',
				cityCode: '',
				cityName: '',
				provinceCode: '',
				provinceName: '',
				venueId: '',
				ctType: '',
				applySize: '',
				teamMin: 6,
				teamMax: 9,
				startScore: 1, //起始点
				applyDate: [],
				AttendanceList: [], //出场名单
				RegistrationList: [], //报名名单
				presidentLimit: 1,
				matchSignStartTime: null,
				matchSignEndTime: null,
				matchStartTime: null,
				imgList: '',
				gameDescription: '',
				matchDescription: '',
				imgDetailList: '',
				repeatSign: 1,
				genderLimit: 2,
				ageLimit: '',
				ageMinMen: undefined,
				ageMaxMen: undefined,
				ageMinWomen: undefined,
				ageMaxWomen: undefined,
				scoreMin: 0,
				teamNum: 16,
				venueAddress: '',
				ctRefundList: [],
				ctEnrollPriceList: [
					{
						id: null,
						name: '团队费用',
						price: 0.0
					}
				],
				competitionClub: {
					adjustAppearListStartTime: '',
					adjustAppearListEndTime: '',
					adjustEnrollListStartTime: '',
					adjustEnrollListEndTime: '',
					sixthMan: 1
				},
				changeSignStartTime: null,
				changeSignEndTime: null,
				changeShowStartTime: null,
				changeShowEndTime: null,
				// recommend: 1, // 是否首页推荐
				sixthPerson: 1, // 是否第六人
				matchFormat: '', // 赛制
				firstFormat: null,
				FirstCompetition: '',
				SecondCompetition: '',
				SecondCompetisixthMantion: '',
				groupNum: '', //组数
				secondFormat: '', //第二赛制
				crossNum: '', //交叉数
				ecertList: [] //电子证书设置
			},
			SecondCompetition: [
				{ value: 2, label: '同名次小组循环赛' },
				{ value: 3, label: '同名次淘汰附加赛' },
				{ value: 4, label: '交叉淘汰附加赛' }
			],
			FirstCompetition: [
				{ value: 0, label: '淘汰附加赛' },
				{ value: 1, label: '小组循环赛' }
			],
			CrossingNum: [
				{ value: '2', label: '2' }
				// { value: '4', label: '4' },
				// { value: '8', label: '8' }
			],
			NumberList: [
				{ key: 2, label: '2名' },
				{ key: 4, label: '4名' },
				{ key: 6, label: '6名' },
				{ key: 8, label: '8名' }
			],
			prizeList: [
				{ key: 1, label: '一等奖' },
				{ key: 2, label: '二等奖' },
				{ key: 3, label: '三等奖' },
				{ key: 4, label: '四等奖' }
			],
			listImageUrlCert: [],
			flagType: '',
			loading: null,
			ctDisabled: true,
			matchStartTimePlaceholder: '必须先选择报名时间',
			pickerOptions: {
				// disabledDate: (time) => {
				//   return time <= new Date() - 1000 * 60 * 59 * 24
				// }
			},
			pickerOptionsCt: null,
			pickerOptionsCt1: null,
			pickerOptionsCt2: null,
			rules: {
				matchName: [
					{
						required: true,
						message: '比赛名称不能为空!',
						trigger: 'blur'
					},
					{ max: 40, message: '长度不能超过40个字符!' }
				],
				userGroupId: [
					{
						required: true,
						message: '主办方不能为空!',
						trigger: 'change'
					}
				],
				venueId: [
					{
						required: true,
						message: '主办场地不能为空!',
						trigger: 'change'
					}
				],
				ctType: [
					{
						required: true,
						message: '比赛类型不能为空!',
						trigger: 'change'
					}
				],
				// crossNum: [
				//     { validator: validatePass, trigger: 'change' }
				//   ],
				applySize: [
					{
						required: true,
						message: '签位不能为空!',
						trigger: 'blur'
					},
					{
						max: 10,
						message: '签位不能超过10个字符!',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9]*[1-9][0-9]*$/,
						message: '请输入正整数',
						trigger: 'blur'
					}
				],
				applyDate: [
					{
						required: true,
						message: '报名时间不能为空!',
						trigger: 'change'
					}
				],
				RegistrationList: [
					{
						required: true,
						message: '调整报名名单时间不能为空!',
						trigger: 'change'
					}
				],
				AttendanceList: [
					{
						required: true,
						message: '调整出场名单时间不能为空!',
						trigger: 'change'
					}
				],
				matchStartTime: [
					{
						required: true,
						message: '比赛时间不能为空!',
						trigger: 'blur'
					}
				],
				teamNum: [
					{
						required: true,
						message: '级别队伍数量不能为空!',
						trigger: 'blur'
					}
				],

				matchDescription: [
					{
						required: true,
						message: '报名须知不能为空!',
						trigger: 'blur'
					},
					// { max: 1000, message: '长度不能超过1000个字符!' }
				],
				FirstCompetition: [
					{
						required: true,
						message: '赛制不能为空!',
						trigger: 'change'
					}
				],
				startScore: [
					{
						required: true,
						message: '积分起始点不能为空!',
						trigger: 'change'
					}
				]
			},
			visible: false,
			listImageUrl: '',
			detailImageUrl: '',
			openImg: '',
			gameSystems: [] // 赛制
		}
	},
	mounted () {
		//this.restaurants = this.loadAll()
		this.initCity()
		// 获取赛制属性列表(字典项) // E_CERT_ REWARD_LEVEL 电子证书 MATCH_FORMAT 赛制
		commomDictData('MATCH_FORMAT', this).then((res) => {
			this.gameSystems = res.list
		})
	},
	methods: {
		changectType (value) {
			if (value === 5) {
				this.checkedCities = ['9', '10', '11', '12']
				this.changeclubLimit(this.checkedCities)
				for (var i = 0; i < this.cities.length; i++) {
					if (i > 7) {
						this.cities[i].disabed = false
					} else {
						this.cities[i].disabed = true
					}
				}
			}
			if (value === 6) {
				this.checkedCities = [
					'1',
					'2',
					'3',
					'4',
					'5',
					'6',
					'7',
					'8'
				]
				this.changeclubLimit(this.checkedCities)
				for (var i = 0; i < this.cities.length; i++) {
					if (i < 8) {
						this.cities[i].disabed = false
					} else {
						this.cities[i].disabed = true
					}
				}
			}
		},
		handleCheckedCitiesChange (value) {
			console.log(this.cities)
			console.log(value)
			this.changeclubLimit(value)
		},
		changeclubLimit (value) {
			let arr = ''
			value.forEach((item, index) => {
				if (index == 0) {
					arr = item
				} else {
					arr = arr + ',' + item
				}
			})
			this.ruleForm.clubLimit = arr
		},
		changeGpnumber () {
			this.$forceUpdate()
			// if (this.ruleForm.groupNum !== '' && this.ruleForm.groupNum !== null) {
			//   if (16 / this.ruleForm.groupNum === 2 || 16 / this.ruleForm.groupNum === 3 || 16 / this.ruleForm.groupNum === 4 || 16 / this.ruleForm.groupNum === 5 || 16 / this.ruleForm.groupNum === 6) {

			//   } else {
			//     return this.applychecking()
			//   }
			// }
		},
		changeappsize () {
			// if (this.ruleForm.FirstCompetition == 0) {
			//   if (this.ruleForm.applySize > 128) {
			//     return this.applytesting()
			//   }
			// }
			// if (this.ruleForm.groupNum !== '' && this.ruleForm.groupNum !== null) {
			//   if (16 / this.ruleForm.groupNum === 2 || 16 / this.ruleForm.groupNum === 3 || 16 / this.ruleForm.groupNum === 4 || 16 / this.ruleForm.groupNum === 5 || 16 / this.ruleForm.groupNum === 6) {

			//   } else {
			//     return this.applychecking()
			//   }
			// }
			this.VerificationInfo()
		},
		changeGroupNum () {
			this.$forceUpdate()
			// 修改第二赛制验证限制
			if (
				this.ruleForm.groupNum == 1 ||
				this.ruleForm.groupNum == ''
			) {
				this.ruleForm.SecondCompetition = ''
				this.ruleForm.crossNum = ''
			}
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.SecondCompetition == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
			// 如果第二赛制为淘汰赛需要验证
			if (this.ruleForm.SecondCompetition == 4) {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking1()
				}
			}
			// 签位和组数的验证
			if (
				this.ruleForm.groupNum !== '' &&
				this.ruleForm.groupNum !== null
			) {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						3 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						5 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking()
				}
			}
		},
		changeSecondCompeti () {
			this.$forceUpdate()
			// 如果第二赛制为淘汰赛需要验证
			if (this.ruleForm.SecondCompetition != 4) {
				this.ruleForm.crossNum = ''
			} else {
				if (
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						2 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						4 ||
					this.ruleForm.teamNum / this.ruleForm.groupNum ===
						6
				) {
				} else {
					return this.applychecking1()
				}
			}
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.SecondCompetition == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
		},
		changecrossNum () {
			this.$forceUpdate()
		},
		changeFirstCompetition () {
			// 第一赛制选择的限制
			//console.log(this.ruleForm.FirstCompetition)
			if (
				this.ruleForm.FirstCompetition == 0 ||
				this.ruleForm.FirstCompetition == ''
			) {
				this.ruleForm.groupNum = ''
				this.ruleForm.SecondCompetition = ''
				this.ruleForm.crossNum = ''
				// this.VerificationInfo()
			}
			this.$forceUpdate()
		},
		// 签位数应小于128，并且组数要被签位数整除
		VerificationInfo () {
			const isDivisible = (dividend, divisor) =>
				dividend % divisor === 0
			if (
				this.ruleForm.ctType === 5 &&
				this.ruleForm.teamNum !== '' &&
				this.ruleForm.teamNum !== null
			) {
				if (
					this.ruleForm.applySize / this.ruleForm.teamNum >
					4
				) {
					this.applytesting()
					return false
				}
			}
			if (
				this.ruleForm.ctType === 6 &&
				this.ruleForm.teamNum !== '' &&
				this.ruleForm.teamNum !== null
			) {
				if (
					this.ruleForm.applySize / this.ruleForm.teamNum >
					8
				) {
					this.applytesting1()
					return false
				}
			}
			if (
				!isDivisible(
					this.ruleForm.applySize,
					this.ruleForm.teamNum
				)
			) {
				this.applytestingnumber()
			}
		},
		tiemchecking () {
			this.$alert(
				'因二阶段同名次小组循环赛系统支持2-6签的小组对阵，故一阶段小组循环赛分组数也需满足2-6组。请重新设置组数！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
			return false
		},
		applytesting () {
			this.$alert(
				'挑战赛事总分组（即总签位 / 级别队伍数）应不大于4！。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applytesting1 () {
			this.$alert(
				'群英赛事总分组（即总签位 / 级别队伍数）应不大于8！。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applytestingnumber () {
			this.$alert(
				'当前系统支持签位数必须为级别队伍数量的倍数。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applychecking () {
			this.$alert(
				'当前系统支持单组（即级别队伍数量/组数）签位数为2/3/4/5/6签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applychecking1 () {
			this.$alert(
				'当前系统支持单组（即级别队伍数量/组数）签位数为2/4/6签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		// 删除电子证书
		deletecertImg (item, index) {
			this.listImageUrlCert.splice(index, 1)
		},
		// 鼠标移入
		hoverover (item) {
			//console.log(item)
			this.deletesId = item.imgUrl
		},
		hoverover1 (item) {
			//console.log(item)
			this.activecolor = item.imgUrl
			//console.log(this.activecolor)
			// this.$nextTick(() => {
			//   this.activecolor = item.id
			// })
			// this.$set(this.activecolor, item.id)
		},
		// 鼠标移出
		hoverout (item) {
			//console.log(item)
			this.deletesId = -1
		},
		hoverout2 (item) {
			//console.log(item)
			this.activecolor = -1
		},
		teamMaxChange (value) {
			this.teamMinSelect = value
		},
		teamMinChange (value) {
			this.teamMaxSelect = value
		},
		init (id, flagType) {
			this.clickFlag = false
			this.flagType = flagType
			this.ruleForm.id = id || null
			this.visible = true
			this.$nextTick(() => {
				this.$refs['ruleForm'].resetFields()
				this.$refs['d2-quill'].Quill.pasteHTML('')
			})
			//数据初始化
			this.ctDisabled = true
			this.matchStartTimePlaceholder = '必须先选择报名时间'
			this.listImageUrl = ''
			this.detailImageUrl = ''
			this.ruleForm.ageMinMen = undefined
			this.ruleForm.ageMaxMen = undefined
			this.ruleForm.ageMinWomen = undefined
			this.ruleForm.ageMaxWomen = undefined
			this.ctRefund.minDuration = 0
			this.ctRefund.refundScale = 0
			this.ctRefund.index = 0
			this.ruleForm.competitionClub = {
				adjustAppearListStartTime: '',
				adjustAppearListEndTime: '',
				adjustEnrollListStartTime: '',
				adjustEnrollListEndTime: '',
				sixthMan: 1
			}
			this.ruleForm.ctRefundList = []
			this.delTableList = []
			this.ruleForm.matchSignStartTime = ''
			this.ruleForm.matchSignEndTime = ''
			this.ruleForm.FirstCompetition = ''
			this.ruleForm.groupNum = ''
			this.ruleForm.SecondCompetition = ''
			this.ruleForm.crossNum = ''
			this.ruleForm.AttendanceList = []
			this.ruleForm.RegistrationList = []
			this.ruleForm.teamNum = 16
			this.listImageUrlCert = []
			this.selClear()
			this.cityDisbaled = true
			this.provinceDisabled = true
			this.venueIdDisabled = true
			this.womenDisabled = false
			this.menDisabled = false
			this.nameFont = 40
			this.$nextTick(() => {
				this.pickerOptionsCt = null
				this.pickerOptionsCt1 = null
				this.pickerOptionsCt2 = null
			})
			this.dataInit()
			//修改回选
			if (this.ruleForm.id) {
				this.$http({
					url: this.$http.adornUrl(
						`/ctCompetition/getId/` + this.ruleForm.id
					),
					method: 'get'
				}).then((data) => {
					if (data && data.code === 0) {
						//console.log(data, '俱乐部竞赛详情')

						this.changeCity(data.bean.userGroupId)
						this.genderLimitChange(
							data.bean.genderLimit
						)
						this.ruleForm = data.bean
						this.ruleForm.teamNum = data.bean.teamNum
							? data.bean.teamNum
							: 16
						if (this.ruleForm.competitionClub) {
							this.ruleForm.competitionClub.sixthMan = this
								.ruleForm.competitionClub
								.sixthMan
								? 1
								: 0
						} else {
							this.ruleForm.competitionClub = {
								sixthMan: -1
							} //默认是否第六人为1
						}
						// 俱乐部等级
						if (data.bean.clubLimit) {
							this.checkedCities = data.bean.clubLimit.split(
								','
							)
							console.log(this.checkedCities)
							console.log(this.cities)
							if (this.ruleForm.ctType == 5) {
								for (
									var i = 0;
									i < this.cities.length;
									i++
								) {
									if (i > 7) {
										this.cities[
											i
										].disabed = false
									} else {
										this.cities[
											i
										].disabed = true
									}
								}
							} else {
								for (
									var i = 0;
									i < this.cities.length;
									i++
								) {
									if (i < 8) {
										this.cities[
											i
										].disabed = false
									} else {
										this.cities[
											i
										].disabed = true
									}
								}
							}
						}
						this.listImageUrl = data.bean.imgUrlList
						this.detailImageUrl = data.bean.imgUrlDetail
						this.changeProvice(0)
						this.selectCity(0)
						this.dataInit()
						this.nameFont =
							40 - data.bean.matchName.length
						this.ruleForm.recommend =
							data.bean.recommend * 1
						this.ruleForm.applyDate = []
						this.ruleForm.applyDate.push(
							data.bean.matchSignStartTime + ''
						)
						this.ruleForm.applyDate.push(
							data.bean.matchSignEndTime + ''
						)

						this.ruleForm.ctEnrollPriceList = data.eList
						// this.listImageUrlCert = data.bean.
						if (data.bean.ecertList !== []) {
							data.bean.ecertList.forEach(
								(element) => {
									let come = {
										imgUrl: '',
										rewardLevel: ''
									}
									come.rewardLevel =
										element.rewardLevel
									come.imgUrl =
										element.imgUrl
									this.listImageUrlCert.push(
										come
									)
								}
							)
						}
						this.ruleForm.RegistrationList = []
						this.ruleForm.AttendanceList = []
						// this.ruleForm.RegistrationList.push(data.bean.competitionClub.adjustAppearListStartTime)
						// this.ruleForm.RegistrationList.push(data.bean.competitionClub.adjustAppearListEndTime)
						// this.ruleForm.AttendanceList.push(data.bean.competitionClub.adjustEnrollListStartTime)
						// this.ruleForm.AttendanceList.push(data.bean.competitionClub.adjustEnrollListEndTime)
						this.ruleForm.RegistrationList = []
						this.ruleForm.AttendanceList = []
						if (data.bean.competitionClub != null) {
							this.ruleForm.RegistrationList.push(
								data.bean.competitionClub
									.adjustAppearListStartTime +
									''
							)
							this.ruleForm.RegistrationList.push(
								data.bean.competitionClub
									.adjustAppearListEndTime +
									''
							)
							this.ruleForm.AttendanceList.push(
								data.bean.competitionClub
									.adjustEnrollListStartTime +
									''
							)
							this.ruleForm.AttendanceList.push(
								data.bean.competitionClub
									.adjustEnrollListEndTime +
									''
							)
							this.ruleForm.competitionClub.sixthMan = data
								.bean.competitionClub.sixthMan
								? 1
								: 0
						}
						if (
							data.bean.competitionMatchFormatList
								.length != 0
						) {
							this.ruleForm.FirstCompetition =
								data.bean.competitionMatchFormatList[0].matchFormat
							this.ruleForm.groupNum =
								data.bean.competitionMatchFormatList[0].groupNum
							if (
								data.bean
									.competitionMatchFormatList
									.length > 1
							) {
								this.ruleForm.SecondCompetition =
									data.bean.competitionMatchFormatList[1].matchFormat
								this.ruleForm.crossNum =
									data.bean.competitionMatchFormatList[1].crossNum
							}
						}
						this.ruleForm.ctRefundList = []
						let index = 1

						if (data.rList.length > 0) {
							for (let i of data.rList) {
								this.ruleForm.ctRefundList.push(
									{
										index: index++,
										minDuration:
											i.minDuration,
										refundScale:
											i.refundScale
									}
								)
							}
						}
						this.ctDisabled = false
						this.$nextTick(() => {
							this.$refs[
								'd2-quill'
							].Quill.pasteHTML(
								data.bean.gameDescription
							)
						})
					}
				})
			}
		},
		selectCity (flag) {
			if (flag !== 0) {
				this.venueList = []
				this.ruleForm.venueId = ''
			}
			this.$http({
				url: this.$http.adornUrl('/pbPlaces/getPlaceById'),
				method: 'get',
				params: this.$http.adornParams({
					orgId: this.ruleForm.userGroupId,
					proviceId: this.ruleForm.provinceCode,
					cityId: this.ruleForm.cityCode
				})
			}).then((data) => {
				let obj = {}
				let val = this.ruleForm.cityCode
				if (val) {
					obj = this.cityList.find((item) => {
						return item.citycode === val
					})
					if (obj) {
						this.ruleForm.cityName = obj.cityname
					}
				}
				this.venueList =
					data && data.code === 0 ? data.list : []
			})
		},
		changeProvice (flag) {
			if (flag !== 0) {
				this.cityList = []
				this.ruleForm.cityCode = ''
				this.venueList = []
				this.ruleForm.venueId = ''
			}
			this.$http({
				url: this.$http.adornUrl(
					'/dicProvinceCity/queryByOrgId'
				),
				method: 'get',
				params: this.$http.adornParams({
					orgId: this.ruleForm.userGroupId,
					provinceCode: this.ruleForm.provinceCode
				})
			}).then((data) => {
				let obj = {}
				let val = this.ruleForm.provinceCode
				if (val) {
					obj = this.provinceList.find((item) => {
						return item.code === val
					})
					if (obj) {
						this.ruleForm.provinceName = obj.name
					}
				}

				this.cityList = data.list
			})
		},
		dataInit () {
			this.ruleForm.ctEnrollPriceList = [
				{
					name: '团队费用',
					price: 0.0
				}
			]
		},
		descInput () {
			let len = 40 - this.ruleForm.matchName.length
			this.nameFont = len
		},
		openFullScreen () {
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
		},
		//新增方法
		ruleFormSubmit () {
			this.$refs['ruleForm'].validate((valid) => {
				//console.log(this.ruleForm)
				if (this.ruleForm.SecondCompetition == 4) {
					if (
						this.ruleForm.crossNum == '' ||
						this.ruleForm.crossNum == null
					) {
						return this.$message.error('请选择交叉数')
					}
				}
				this.ruleForm.competitionMatchFormatList = [
					{
						matchFormat: this.ruleForm.FirstCompetition,
						stage: 1,
						groupNum: this.ruleForm.groupNum
					},
					{
						matchFormat: this.ruleForm
							.SecondCompetition,
						stage: 2,
						crossNum: this.ruleForm.crossNum
					}
				]
				// 如果第二赛制为同名次小组循环赛需要验证
				if (this.ruleForm.SecondCompetition == 2) {
					if (
						this.ruleForm.groupNum >= 2 &&
						this.ruleForm.groupNum <= 6
					) {
					} else {
						return this.tiemchecking()
					}
				}
				this.ruleForm.ecertList = this.listImageUrlCert
				if (
					this.ruleForm.SecondCompetition == '' ||
					this.ruleForm.SecondCompetition == null
				) {
					if (this.ruleForm.groupNum > 1) {
						return this.$message.error(
							'赛制仅为小组循环赛，组数只支持单组！'
						)
					}
				}
				// 组数和签位之间的限制
				if (this.ruleForm.FirstCompetition == 1) {
					if (
						this.ruleForm.groupNum == '' ||
						this.ruleForm.groupNum == null
					) {
						return this.groupNumNull()
					}
				}
				// if (
				// 	this.ruleForm.FirstCompetition == 0 ||
				// 	this.ruleForm.FirstCompetition == ''
				// ) {
				// 	this.ruleForm.groupNum = ''
				// 	this.ruleForm.SecondCompetition = ''
				// 	this.ruleForm.crossNum = ''
				// 	if (this.ruleForm.applySize > 128) {
				// 		return this.applytesting()
				// 	}
				// }
				if (
					this.ruleForm.ctType === 5 &&
					this.ruleForm.teamNum !== '' &&
					this.ruleForm.teamNum !== null
				) {
					if (
						this.ruleForm.applySize /
							this.ruleForm.teamNum >
						4
					) {
						this.applytesting()
						return false
					}
				}
				if (
					this.ruleForm.ctType === 6 &&
					this.ruleForm.teamNum !== '' &&
					this.ruleForm.teamNum !== null
				) {
					if (
						this.ruleForm.applySize /
							this.ruleForm.teamNum >
						8
					) {
						this.applytesting1()
						return false
					}
				}
				if (
					this.ruleForm.groupNum !== '' &&
					this.ruleForm.groupNum !== null
				) {
					if (
						this.ruleForm.teamNum /
							this.ruleForm.groupNum ===
							2 ||
						this.ruleForm.teamNum /
							this.ruleForm.groupNum ===
							3 ||
						this.ruleForm.teamNum /
							this.ruleForm.groupNum ===
							4 ||
						this.ruleForm.teamNum /
							this.ruleForm.groupNum ===
							5 ||
						this.ruleForm.teamNum /
							this.ruleForm.groupNum ===
							6
					) {
					} else {
						return this.applychecking()
					}
				}
				if (this.ruleForm.ctRefundList.length < 1) {
					return this.$message.error('必须设置退费规则！')
				} else if (
					this.ruleForm.ctEnrollPriceList.some(
						(e) => e.price == 0
					)
				) {
					return this.$message.error('费用设置不能为0！')
				} else if (this.ruleForm.ecertList.length < 1) {
					return this.$message.error('请上传电子证书！')
				}
				const isDivisible = (dividend, divisor) =>
					dividend % divisor === 0
				// if (this.ruleForm.applySize > 128) {
				// 	return this.applytesting()
				// }
				if (
					!isDivisible(
						this.ruleForm.applySize,
						this.ruleForm.teamNum
					)
				) {
					return this.applytestingnumber()
				}
				if (valid) {
					this.$showLoading()
					this.ruleForm.matchSignStartTime = this.ruleForm.applyDate[0]
					this.ruleForm.matchSignEndTime = this.ruleForm.applyDate[1]
					this.$http({
						url: this.$http.adornUrl(
							`/ctCompetition/${
								!this.ruleForm.id
									? 'save'
									: 'update'
							}`
						),
						method: 'post',
						data: this.ruleForm
					}).then((data) => {
						if (data && data.code === 0) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.flagType = 1
									this.visible = false
									this.$emit(
										'refreshDataList'
									)
									this.$showLoading('close')
								}
							})
						} else {
							this.$message.error(data.msg)
							this.$showLoading('close')
						}
					})
				}
			})
		},
		closeForm () {
			if (this.flagType === 2) {
				this.$http({
					url: this.$http.adornUrl(
						`/ctCompetition/delete/` + this.ruleForm.id
					),
					method: 'get'
				}).then((data) => {
					this.visible = false
				})
			} else {
				this.visible = false
			}
		},
		//报名时间改变事件
		applyDateChange (val) {
			//console.log(this.ruleForm.applyDate, 8989)
			this.ruleForm.RegistrationList = []
			this.ruleForm.AttendanceList = []
			this.ruleForm.matchStartTime = null
			this.pickerOptionsCt = null
			if (this.ruleForm.applyDate == null) {
				this.ruleForm.applyDate = []
				this.defaultTime = []
				this.ctDisabled = true
				this.ruleForm.matchStartTime = null
				this.matchStartTimePlaceholder = '必须先选择报名时间'
			} else {
				// alert(2)
				this.ctDisabled = false
				this.ruleForm.matchStartTime = null
				this.matchStartTimePlaceholder = '请选择比赛时间'
				// console.log(this.ruleForm.applyDate)
				if (this.ruleForm.applyDate[1]) {
					this.pickerOptionsCt = {
						disabledDate: (time) => {
							return (
								time <
								// new Date(this.ruleForm.applyDate[0])
								this.timechange(
									this.ruleForm.applyDate[0]
								)
							)
						}
					}
				}
				// console.log(this.pickerOptionsCt)
			}
		},
		groupNumNull () {
			this.$alert('赛制为小组循环赛，组数不能位空！！', '提示', {
				confirmButtonText: '确定',
				callback: (action) => {
					this.$message({
						type: 'info',
						message: `请重新设置`
					})
				}
			})
			return false
		},
		applyDateChange1 (val) {
			this.ruleForm.AttendanceList = []
			this.ruleForm.matchStartTime = null
			if (this.ruleForm.RegistrationList == null) {
				this.ruleForm.RegistrationList = []
				return
			}
			if (!this.changeSignUpStartTime()) {
				return
			}
			if (this.ruleForm.RegistrationList[1]) {
				this.pickerOptionsCt1 = {
					disabledDate: (time) => {
						return (
							time <
							// new Date(this.ruleForm.RegistrationList[1])
							this.timechange(
								this.ruleForm
									.RegistrationList[1]
							)
						)
					}
				}
				//console.log(this.pickerOptionsCt1)
			}
			if (this.ruleForm.RegistrationList.length > 0) {
				//console.log(this.ruleForm.RegistrationList)
				this.ruleForm.competitionClub.adjustAppearListStartTime = this.ruleForm.RegistrationList[0]
				this.ruleForm.competitionClub.adjustAppearListEndTime = this.ruleForm.RegistrationList[1]
			} else {
			}
		},
		applyDateChange2 (val) {
			this.ruleForm.matchStartTime = null

			if (this.ruleForm.AttendanceList == null) {
				this.ruleForm.AttendanceList = []
				return
			}
			if (!this.changeShowUpStartTime()) {
				return
			}
			if (this.ruleForm.AttendanceList[1]) {
				this.pickerOptionsCt2 = {
					disabledDate: (time) => {
						return (
							time <
							//  new Date(this.ruleForm.AttendanceList[1])
							this.timechange(
								this.ruleForm.AttendanceList[1]
							)
						)
					}
				}
			}

			if (this.ruleForm.AttendanceList.length > 0) {
				this.ruleForm.competitionClub.adjustEnrollListStartTime = this.ruleForm.AttendanceList[0]
				this.ruleForm.competitionClub.adjustEnrollListEndTime = this.ruleForm.AttendanceList[1]
			} else {
			}
		},
		timechange (item) {
			if (item) {
				// console.log(item)
				const dateList = item.split(/[- :]/)
				// let nndate = new Date(dateList[0], dateList[1] - 1, dateList[2], dateList[3], dateList[4], '00')
				let nndate = new Date(
					dateList[0],
					dateList[1] - 1,
					dateList[2],
					'00',
					'00',
					'00'
				)
				return nndate
			}
		},
		changeMatchStartTime () {
			if (
				this.ruleForm.matchStartTime &&
				this.ruleForm.AttendanceList[1]
			) {
				let date1 = new Date(
					this.ruleForm.AttendanceList[1]
				).getTime()
				let date2 = new Date(
					this.ruleForm.matchStartTime
				).getTime()
				if (date1 > date2 || date1 === date2) {
					this.ruleForm.matchStartTime = null
					this.$message.error(
						'比赛时间必须>调整出场截止时间'
					)
					this.matchStartTimePlaceholder =
						'比赛时间必须晚于调整出场截止时间，请重新选择'
				}
			}
			if (
				this.ruleForm.matchStartTime &&
				this.ruleForm.applyDate[1]
			) {
				let date1 = new Date(
					this.ruleForm.applyDate[1]
				).getTime()
				let date2 =
					new Date(this.ruleForm.matchStartTime).getTime() -
					1000 * 60
				if (date1 > date2) {
					this.ruleForm.matchStartTime = null
					this.matchStartTimePlaceholder =
						'比赛时间必须晚于报名截止时间，请重新选择'
				}
			}
		},
		changeSignUpStartTime () {
			if (
				this.ruleForm.RegistrationList[0] &&
				this.ruleForm.applyDate[0]
			) {
				let date1 = new Date(
					this.ruleForm.applyDate[0]
				).getTime()
				let date2 = new Date(
					this.ruleForm.RegistrationList[0]
				).getTime()
				if (date1 > date2) {
					this.ruleForm.RegistrationList = []
					this.$message.error(
						'调整报名名单时间应>=比赛报名开始时间'
					)
					return false
				}
				return true
			}
		},
		changeShowUpStartTime () {
			if (
				this.ruleForm.AttendanceList[0] &&
				this.ruleForm.RegistrationList[0]
			) {
				let date1 = new Date(
					this.ruleForm.RegistrationList[1]
				).getTime()
				let date2 = new Date(
					this.ruleForm.AttendanceList[0]
				).getTime()
				if (date1 > date2) {
					this.ruleForm.AttendanceList = []
					this.$message.error(
						'调整出场名单开始时间应>=调整报名名单截止时间'
					)
					return false
				}
				return true
			}
		},
		//打开图片剪裁框
		openImgdailog (type) {
			this.openImg = true
			this.$nextTick(() => {
				if (type === 1) {
					this.$refs.upimg.init('ctLevel') //传入图片类型参数
				}
				if (type === 2) {
					this.$refs.upimg2.init('ctLevel') //传入图片类型参数
				}
				if (type === 3) {
					if (this.ruleForm.prizeList) {
						this.$refs.upimg3.init('ctLevel') //传入图片类型参数
					} else {
						this.$message.error('请选择奖项等级')
					}
				}
			})
		},
		//剪裁完成的回显 列表页
		doneup_lb (val, url) {
			this.ruleForm.imgList = val
			this.listImageUrl = url
			this.openImg = false
		},
		//剪裁完成的回显 详情页
		doneup_xq (val, url) {
			this.ruleForm.imgDetailList = val
			this.detailImageUrl = url
			this.openImg = false
		},
		//电子整数 列表页
		doneup_Cert (val, url, path) {
			this.ruleForm.CertimgList = val
			let arr = {
				imgUrl: path,
				rewardLevel: this.ruleForm.prizeList
			}
			console.log(this.verificationBook(path))
			if (this.verificationBook(path)) {
				this.listImageUrlCert.push(arr)
			}
			console.log(val, url, path)
			this.openImg = false
		},
		// 验证证书是否已经上传
		verificationBook (path) {
			let arr = 1

			this.listImageUrlCert.forEach((item, index) => {
				console.log(item.rewardLevel)
				console.log(this.ruleForm.prizeList)
				if (item.rewardLevel == this.ruleForm.prizeList) {
					this.listImageUrlCert[index].imgUrl = path
					arr = 0
					throw Error()
				}
				arr = 1
			})
			if (arr === 0) {
				return false
			} else {
				return true
			}
		},
		//自定义上传方法
		//没有用el-upload的action方法，如果使用要传递headers属性参数授权
		uploadFileList (param) {
			//列表页图
			this.uploadFile('1', param.file)
		},
		uploadFileDetail (param) {
			//列表页图
			this.uploadFile('2', param.file)
		},
		uploadFile (type, file) {
			let fd = new FormData()
			fd.append('type', 'ctLevel')
			fd.append('file', file)

			this.$http({
				url: this.$http.adornUrl(`/upload/uploadFile`),
				method: 'post',
				data: fd
			}).then((data) => {
				if (data && data.code === 0) {
					//列表页图
					if (type === '1') {
						this.ruleForm.imgList = data.bean.id
						this.listImageUrl = URL.createObjectURL(
							file
						)
					}
					//详情页图
					if (type === '2') {
						this.ruleForm.imgDetailList = data.bean.id
						this.detailImageUrl = URL.createObjectURL(
							file
						)
					}
					this.$message.success('上传成功!')
				} else {
					this.$message.error('上传失败!')
				}
			})
		},
		// querySearchApplySize(queryString, cb){
		//     let restaurants = this.restaurants;
		//     let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
		//     // 调用 callback 返回建议列表的数据
		//     cb(results);
		// },
		// createFilter(queryString) {
		//     return (restaurant) => {
		//         return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
		//     };
		// },
		// loadAll(){
		//     return [
		//         {"value":"2签位"},
		//         {"value":"4签位"},
		//         {"value":"8签位"},
		//         {"value":"16签位"},
		//         {"value":"128签位"},
		//         {"value":"128签位"}
		//     ]
		// },
		startAgeMenChange (value) {
			this.ageMaxMenMin = value
		},
		endAgeMenChange (value) {
			this.ageMaxMenMax = value
		},
		startAgeWomenChange (value) {
			this.ageMaxWomenMin = value
		},
		endAgeWomenChange (value) {
			this.ageMaxWomenMax = value
		},
		genderLimitChange (label) {
			//男
			if (label === 0) {
				this.womenDisabled = true
				this.menDisabled = false
				this.ruleForm.ageMinWomen = undefined
				this.ruleForm.ageMaxWomen = undefined
			}
			//女
			if (label === 1) {
				this.menDisabled = true
				this.womenDisabled = false
				this.ruleForm.ageMinMen = undefined
				this.ruleForm.ageMaxMen = undefined
			}
			//全部
			if (label === 2) {
				this.menDisabled = false
				this.womenDisabled = false
			}
		},
		// table多选事件
		selectionChangeHandle (val) {
			this.delTableList = val
			if (this.delTableList.length === 0) {
				this.delCtRefundDisabled = true
			} else {
				this.delCtRefundDisabled = false
			}
		},
		//退款设置添加事件
		addCtRefund () {
			if (this.ctRefund.minDuration === undefined) {
				this.$message.error('距比赛开始时间不能为空!')
				return
			}
			if (this.ctRefund.refundScale === undefined) {
				this.$message.error('退款比例不能为空!')
				return
			}

			let arr = {
				index: this.ruleForm.ctRefundList.length + 1,
				minDuration: this.ctRefund.minDuration,
				refundScale: this.ctRefund.refundScale
			}
			this.ruleForm.ctRefundList.push(arr)
		},
		//退款设置删除事件
		delCtRefund () {
			for (let i of this.delTableList) {
				this.ruleForm.ctRefundList.splice(i.index - 1, 1)
				for (
					let j = 0;
					j < this.ruleForm.ctRefundList.length;
					j++
				) {
					this.ruleForm.ctRefundList[j].index = j + 1
				}
			}
		},
		initCity () {
			this.$http({
				url: this.$http.adornUrl('/sysOrg/list'),
				method: 'get'
			}).then((data) => {
				this.sysOrgList =
					data && data.code === 0 ? data.list : []
			})
		},
		selClear () {
			this.placesInfoList = []
			this.ruleForm.venueAddress = ''
			this.ruleForm.venueId = ''
			this.venueList = []
			this.ruleForm.cityCode = ''
			this.ruleForm.cityName = ''
			this.cityList = []
			this.ruleForm.provinceCode = ''
			this.ruleForm.provinceName = ''
			this.provinceList = []
		},
		changeCity (val) {
			this.selClear()
			if (val === '' || val === null) {
				this.cityDisbaled = true
				this.provinceDisabled = true
				this.venueIdDisabled = true
				return
			} else {
				this.cityDisbaled = false
				this.provinceDisabled = false
				this.venueIdDisabled = false
			}
			this.getById(val)
		},
		//获取省和市
		getById (val) {
			this.$http({
				url: this.$http.adornUrl(
					`/dicProvince/queryByOrgId/` + val
				),
				params: this.$http.adornParams({
					orgId: val
				}),
				method: 'get'
			}).then((data) => {
				if (data && data.code === 0) {
					// this.cityList.push({
					//     label : data.bean.cityName,
					//     value : data.bean.cityCode
					// })
					// this.ruleForm.cityCode = data.bean.cityCode
					// this.ruleForm.cityName = data.bean.cityName
					// this.provinceList.push({
					//     label : data.bean.proviceName,
					//     value : data.bean.code
					// })
					// this.ruleForm.provinceCode = data.bean.code
					// this.ruleForm.provinceName = data.bean.proviceName
					// this.getByOrgId(val)
					this.provinceList = data.list
				}
			})
		},
		//获取主办方
		getByOrgId (val) {
			this.$http({
				url: this.$http.adornUrl(`/pbPlaces/getByOrgId/` + val),
				method: 'get'
			}).then((data) => {
				if (data && data.code === 0) {
					this.placesInfoList = data.pbPlacesList
					for (let i of data.pbPlacesList) {
						this.venueList.push({
							label: i.name,
							value: i.id
						})
					}
				}
			})
		},
		venueIdChange (val) {
			let obj = {}
			if (val) {
				obj = this.venueList.find((item) => {
					return item.id === val
				})
				if (obj) {
					this.ruleForm.venueAddress = obj.address
				}
			}

			// //console.log(this.venueList)
			// if(val == '' || val === null){
			//     this.ruleForm.venueAddress = ''
			// }else{
			//     this.placesInfoList.forEach(data =>{
			//         if(data.id == val){
			//             this.ruleForm.venueAddress = data.address
			//         }
			//     })
			// }
		},
		addFeeTemplate (type) {
			//console.log('type:', type)
			this.addFeeTemplateVisible = true
			this.$nextTick(() => {
				this.$refs.addFeeTemplate.init(type)
			})
		},
		chooseTemplate (list, type) {
			//console.log('选择模板：', type, list)
			this.addFeeTemplateVisible = false
			if (type === 2) {
				this.ruleForm.ctRefundList = []
				let index = 1
				for (let i of list) {
					this.ruleForm.ctRefundList.push({
						index: index++,
						minDuration: i.typeVal,
						refundScale: i.value
					})
				}
			}
		}
	}
}
</script>
<style>
.imagemore {
	/* display: inline-block; */
	margin-top: 20px;
}
.imagelist {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;

	align-items: center;
}
.infocont {
	display: inline-block;
	margin-right: 30px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 5px;
	overflow: hidden;
}
.deletes .el-icon-delete {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 100;
	color: white;
	font-size: 20px;
}
.chosecolor {
	color: #02b90d !important;
}
.deletes {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
}
.deletes .Mask {
	width: 100%;
	height: 100%;
	background: black;
	opacity: 0.8;
	position: absolute;
	left: 0;
	top: 0;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
	border: 1px dashed #ccc;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.width_ct {
	width: 50%;
}
.sel_width_ct,
.input_width_ct {
	width: 20% !important;
}
.font_later {
	padding-left: 20px;
	font-weight: bold;
	color: #909399;
}
.font_color {
	font-weight: bold;
	color: #909399;
}
.font_style {
	font-weight: bold;
	color: red;
}
.dialog-footer {
	padding-bottom: 150px;
}

/* 提示框 */
.el-tooltip__popper.is-light {
	border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
	border-bottom-color: grey !important ;
}

.toolTip > p {
	margin: 0;
	padding-top: 10px;
	height: 14px;
	line-height: 14px;
	font-size: 14px;
	color: #606266;
}
/* 文本框剩余数字提示兼容ie */
.el-input .el-input__count .el-input__count-inner {
	background: none;
	line-height: initial;
	display: inline-block;
	padding: 0 5px;
}
</style>
